import React from 'react';
import Helmet from 'react-helmet';

declare global {
  interface Window {
    oaiq?: any;
  }
}

export const trackInquiryClick = (): void => {
  if (typeof window !== 'undefined' && window.oaiq) {
    window.oaiq('measure', 'registration_completed', {
      type: 'customer_action',
    });
  }
};

const OpenAITracking: React.FC = () => {
  const pixelId = process.env.GATSBY_OPENAI_PIXEL_ID;

  if (!pixelId || (typeof window !== 'undefined' && window.location.hostname !== 'pivot.jp')) return null;

  return (
    <Helmet>
      <script type="text/javascript" async src="https://bzrcdn.openai.com/sdk/oaiq.min.js" />
      <script type="text/javascript">
        {`
          window.oaiq = window.oaiq || function () {
            (window.oaiq.q = window.oaiq.q || []).push(arguments);
          };
          window.oaiq("init", {
            pixelId: "${pixelId}"
          });
        `}
      </script>
    </Helmet>
  );
};

export default OpenAITracking;
